import { Modal, Button } from 'react-bootstrap';
import styles from "./stylesAdmin.module.css"
import { Identifiable } from '../../types/interfaces';
import { useLoading } from "../../components/LoadingContext";

interface ReactivateInactiveModalProps<T extends Identifiable> {
  show: boolean;
  onHide: () => void;
  onReactiveItem: (item: T) => Promise<void>;
  item: T | null;
  itemLabel: string;
  apiUrl: string;
  showNotification: (message: string, variant: "success" | "danger") => void;
}

const ReactivateInactiveModal = <T extends Identifiable>({
  show,
  onHide,
  onReactiveItem,
  item,
  apiUrl,
  showNotification,
}: ReactivateInactiveModalProps<T>) => {
    const { setLoading } = useLoading();
    const handleReactivateItem = async () => {
      setLoading(true);
        if (item) {
          try {
            const response = await fetch(
              `${apiUrl}/${item.id}`,
              {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ activo: 1}),
              }
            );
      
            if (!response.ok) {
              throw new Error("Error al activar el ítem");
            }
            showNotification("Se ha activado con éxito", "success");
            await onReactiveItem(item);
            onHide();
          } catch (error) {
            showNotification("No se puede activar porque tiene otros elementos asignados. Por favor, reasigne los otros elementos antes de proceder.", "danger");
            onHide();
            console.error("Error reactivate item:", error);
          } finally {
            setLoading(false);
          }
        }
    };

  return (
    <Modal show={show} onHide={onHide} className={styles.modalContainer}>
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title className={styles.modalTitle}>Confirmar Reactivación</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>{`¿Está seguro/a de que desea reactivar este elemento?`}</Modal.Body>
      <Modal.Footer className={styles.modalFooter}>
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button variant="success" onClick={handleReactivateItem}>
          Reactivar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReactivateInactiveModal;
